<div class="page-container">
  <app-toolbar [title]="'ACTIVITY_LOG.TITLE' | translate"></app-toolbar>
  <div class="page">
    <div class="activity-log">
      @if (view$ | async; as view) {
        <div class="table-controls">
          @if (view.organizations.length > 1) {
            <app-multi-filter
              name="organizations"
              idKey="id"
              labelTranslationKey="COMMON.ORGANIZATIONS"
              icon="apartment"
              [fontSet]="null"
              [values]="view.selectedOrganizationIds"
              [options]="view.organizations"
              [displayWith]="displayOrganization"
              [displaySelected]="displaySelectedOrganizations(view.organizations)"
              (valueChange)="updateOrganizationIds($event)"
              (clear)="updateOrganizationIds([])"
            ></app-multi-filter>
          }

          <app-filter
            name="users"
            idKey="id"
            labelKey="COMMON.USER"
            icon="person"
            [value]="view.filters.userId"
            [options]="view.users"
            [findWith]="findUser"
            [filterWith]="filterUsers"
            [displayWith]="displayUser"
            (optionSelected)="updateUserId($event)"
            (clear)="updateUserId(null)"
          ></app-filter>

          <app-multi-filter
            name="actions"
            idKey="id"
            labelTranslationKey="ACTIVITY_LOG.ACTION"
            icon="bolt"
            [values]="view.filters.metrics"
            [options]="view.actionOptions"
            [displayWith]="displayAction"
            [displaySelected]="displaySelectedActions"
            (valueChange)="updateMetrics($event)"
            (clear)="updateMetrics([])"
          ></app-multi-filter>

          <mat-chip [class.active]="hasDateRange" (click)="isDateRangeOverlayOpen = true" cdkOverlayOrigin #dateTrigger="cdkOverlayOrigin">
            <div class="chip-content">
              <mat-icon fontIcon="date_range"></mat-icon>
              <span class="clickable text">
                {{ hasDateRange ? (selectedStartDate | date) + ' – ' + (selectedEndDate | date) : ('COMMON.DATE_RANGE' | translate) }}
              </span>
              <mat-icon fontIcon="keyboard_arrow_down"></mat-icon>
              @if (hasDateRange) {
                <button matChipRemove (click)="$event.stopPropagation(); clearDateRange()">
                  <mat-icon>cancel</mat-icon>
                </button>
              }
            </div>
          </mat-chip>

          <ng-template
            cdkConnectedOverlay
            [cdkConnectedOverlayHasBackdrop]="true"
            [cdkConnectedOverlayOrigin]="dateTrigger"
            [cdkConnectedOverlayOpen]="isDateRangeOverlayOpen"
            (backdropClick)="isDateRangeOverlayOpen = false"
          >
            <div class="overlay-container date-range-overlay">
              <mat-form-field subscriptSizing="dynamic">
                <mat-label>{{ 'COMMON.DATE_RANGE' | translate }}</mat-label>
                <mat-date-range-input [rangePicker]="dateRangePicker">
                  <input matStartDate [placeholder]="'COMMON.START_DATE' | translate" [(ngModel)]="selectedStartDate" />
                  <input matEndDate [placeholder]="'COMMON.END_DATE' | translate" [(ngModel)]="selectedEndDate" />
                </mat-date-range-input>
                <mat-hint align="end">{{ 'COMMON.DATE_FORMAT_HINT' | translate }}</mat-hint>
                <mat-datepicker-toggle matIconSuffix [for]="dateRangePicker"></mat-datepicker-toggle>
                <mat-date-range-picker #dateRangePicker></mat-date-range-picker>
              </mat-form-field>
              <button mat-flat-button class="apply-button" (click)="applyDateRange()">{{ 'COMMON.APPLY' | translate }}</button>
            </div>
          </ng-template>
        </div>

        <app-table
          [source]="view.source"
          [columns]="view.columns"
          [rowId]="rowId"
          [selectable]="false"
          tableId="activity-log"
          csvFilename="activity-log"
          label="ACTIVITY_LOG.TITLE"
          rowNoun="ACTIVITY_LOG.PAGINATION.ENTRY"
          rowNounPlural="ACTIVITY_LOG.PAGINATION.ENTRIES"
        />
      }
    </div>
  </div>
</div>
